export default class NumberHelpers {
  static convertMoneyToInteger(value) {
    value = value.replace(',', '');
    while (value.includes('.')) {
      value = value.replace('.', '');
    }
    return Number.parseInt(value);
  }

  static formatMoney(value, places, symbol, thousand, decimal) {
    places = !isNaN((places = Math.abs(places))) ? places : 2;
    symbol = symbol !== undefined ? symbol : '$';
    thousand = thousand || ',';
    decimal = decimal || '.';
    var number = value,
      negative = number < 0 ? '-' : '',
      i = parseInt((number = Math.abs(+number || 0).toFixed(places)), 10) + '',
      j = (j = i.length) > 3 ? j % 3 : 0;
    return (
      symbol +
      negative +
      (j ? i.substr(0, j) + thousand : '') +
      i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousand) +
      (places
        ? decimal +
          Math.abs(number - i)
            .toFixed(places)
            .slice(2)
        : '')
    );
  }

  static getRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
  }

  static formatPrice(price) {
    if (price) {
      price = price.toString();
      if (!price.includes('.') && !price.includes(',')) {
        //centavos
        price = parseFloat(price / 100).toFixed(2);
      } else {
        price = parseFloat(price).toFixed(2);
      }
      return price.replace('.', ',');
    } else return '0,00';
  }
  static centsToReal(price) {
    if (price) {
      price = Number.parseInt(price);
      price = parseFloat(price / 100).toFixed(2);
      return price.replace('.', ',');
    } else return '0,00';
  }

  static convertTimeObjectInMinutes(time) {
    if (!time) return 0;
    let minutes = time.hours ? time.hours * 60 : 0;
    minutes = time.minutes ? time.minutes + minutes : minutes;
    minutes = time.days ? time.days * 24 * 60 + minutes : minutes;
    return minutes;
  }
}
